import { useState, useEffect, useRef } from "react";
import styles from "../../../layout/admin/Main.module.scss";
import { Link } from "react-router-dom";
/*専用コンポーネント*/
import SearchForm from "./CategorySearchForm";
/*共通コンポーネント */
import ScreenTitle from "../../../layout/admin/ScreenTitle";
import SubScreenTitle from "../../../layout/admin/SubScreenTitle";
import DataTable from "../../../features/DataTable";
import Button from "../../../ui/Button";
//API
import { getCategorySearchList } from "../../../../services/apiNotification";

//データテーブル項目
const tableMeata = [
  { key: "name", label: "カテゴリー名" },
  { key: "sort_number", label: "整列順" },
];
const NoticeCategory = () => {
  // 検索条件
  const [searchCondition, setSearchCondition] = useState({});
  // 検索結果
  const [tableData, setTableData] = useState([]);
  const [tableSortData, setTableSortData] = useState([]);
  const tableResetRef = useRef();

  //初回レンダリング
  useEffect(() => {
    setSearchCondition({}); //初期表示_条件なしで検索
  }, []); //初回レンダリング

  //検索条件更新
  useEffect(() => {
    (async function () {
      const data = await getCategorySearchList(searchCondition);
      if (!data) return;
      setTableData(
        data.map((d) => {
          return {
            key: d.id,
            category_name: (
              <Link to={"./edit/update/" + d.id}>{d.category_name}</Link>
            ),
            sort_number: d.sort_number,
          };
        })
      );
      //ソート用の文字列に変換（そのまま渡すと1＞10＞2　で並ぶ）
      //かぶったらIDでソートするためIDも付加
      const getSortStr = (sort_number, id) => {
        return (
          String(sort_number).padStart(10, "0") + String(id).padStart(10, "0")
        );
      };
      setTableSortData(
        data.map((d) => {
          return {
            key: d.id,
            category_name: d.category_name,
            sort_number: getSortStr(d.sort_number, d.id),
          };
        })
      );
      //ページネーション・ソートをリセット
      tableResetRef.current?.click();
    })();
  }, [searchCondition]); //検索条件更新

  return (
    <div className={styles.main}>
      <ScreenTitle>お知らせ管理</ScreenTitle>
      <SubScreenTitle>カテゴリー新規登録</SubScreenTitle>
      <div className={styles.buttonbox__left}>
        <Link to={"./edit/new/0"}>
          <Button styleType="new">カテゴリー新規登録</Button>
        </Link>
      </div>
      <SubScreenTitle>カテゴリー検索</SubScreenTitle>
      <SearchForm setSearchCondition={setSearchCondition}></SearchForm>
      <DataTable
        tableData={tableData}
        tableMeata={tableMeata}
        tableSortData={tableSortData}
        tableResetRef={tableResetRef}
      ></DataTable>
      <div className={styles.buttonbox}>
        <Link className={styles.link} to="/admin/notification">
          お知らせ管理へ戻る
        </Link>
      </div>
      <div className={styles.buttonbox}>
        <Link className={styles.link} to="/admin/top">
          トップページへ戻る
        </Link>
      </div>
    </div>
  );
};
export default NoticeCategory;
